import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';

import CS from '../../commons/services/Common'

export default function BarChart(props) {
    const [options, setOptions] = useState ({});
    const [dataChart, setDataChart] = useState (
        {
            datasets:[],
            labels:[]
        }
    );

    useEffect(() => {
        const fetchData = async () => {
            setDataChart(
                {
                    labels: props.labels,
                    datasets: props.datasets
                }
            );
            setOptions(
                {
                    tooltips: {
                        displayColors: false,
                        callbacks: {
                            title: function(tooltipItems, data) {
                                return '';
                            },
                            label: function (tooltipItem, details) {
                                let dataset = details.datasets[tooltipItem.datasetIndex];
                                let currentValue = dataset.data[tooltipItem.index];
                                return `${dataset.label} : ${CS.setComma(currentValue)}kWh`; 
                            }
                        }
                    },
                    title:{
                        display: false,
                        text: props.text,
                        fontSize: 20
                    },
                    legend:{
                        display: false,
                        position: 'right'
                    },
                    scales: {
                        xAxes: [
                            {
                                display: true,
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display:false
                                },
                                ticks: {
                                    //fontColor: 'rgb(255,255,255)'
                                    userCallback: function(value, index, values) {
                                        if (CS.checkIsNull(props.id)) {
                                            return Number(value.substring(8,10))
                                        } else {
                                            return value;
                                        }
                                        
                                    }
                                }
                            }
                        ],
                        yAxes: [{
                                display: true,
                                //stacked: true,
                                ticks: {
                                    beginAtZero: true,
                                    suggestedMin: 0,
                                    //suggestedMax: 10
                                }
                            }]
                    },
                }
            );
        };
        fetchData();
    }, [props.datasets]);

    return (
        <>
            <Bar 
                data={dataChart}
                width={300}
                height={100}
                options={options}
            />
        </>
    );
}
